module.exports = __webpack_public_path__ + "static/media/env4.249f492b.png";